import { LoadingService } from '../../../shared/services/loading/loading.service.ts';

export const bakery2bTabLoadingService = new LoadingService();
